/**
 * Stores a 2 layer WeakMap based-cache. Useful for caching 2 argument functions.
 */
export class DoubleWeakMap<T1 extends object, T2 extends object, T3 extends object> {
  private map: WeakMap<T1, WeakMap<T2, T3>> = new WeakMap();

  get(a: T1, b: T2): T3 | undefined {
    const cache = this.map.get(a);
    if (cache) {
      const val = cache.get(b);
      if (val) {
        return val;
      }
    }
    return undefined;
  }

  set(a: T1, b: T2, val: T3): T3 {
    let cache = this.map.get(a);
    if (!cache) {
      cache = new WeakMap<T2, any>();
      this.map.set(a, cache);
    }

    cache.set(b, val);

    return val;
  }
}
